import { render, staticRenderFns } from "./mailling-templates.vue?vue&type=template&id=40c70268&scoped=true"
import script from "./mailling-templates.vue?vue&type=script&lang=js"
export * from "./mailling-templates.vue?vue&type=script&lang=js"
import style0 from "./mailling-templates.vue?vue&type=style&index=0&id=40c70268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c70268",
  null
  
)

export default component.exports